import React from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';
import Image from 'src/components/atoms/image';

import { useBreakpointV3 } from '@helpers/use';

type DownloadAppProps = {
  GOOGLE_PLAY_URL: string;
  APP_STORE_URL: string;
};

const DownloadApp = ({ GOOGLE_PLAY_URL, APP_STORE_URL }: DownloadAppProps) => {
  const { t } = useTranslation('common');
  const theme = useTheme();
  const { isMobile } = useBreakpointV3();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { md: 'flex-start', xs: 'center' }, gap: '16px' }}>
      <Typography variant="body2lanna" color={theme.palette.textV2.primary}>
        {t('home.footer.download_app')}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignSelf: { md: 'flex-start', xs: 'center' },
          gap: '8px',
        }}
      >
        <Box onClick={() => window.open(GOOGLE_PLAY_URL, '_blank')} sx={{ cursor: 'pointer' }}>
          <Image
            style={{ height: isMobile ? '41px' : '27px' }}
            src="/static/icons/footer/google-play.svg"
            alt="play-store"
          />
        </Box>
        <Box onClick={() => window.open(APP_STORE_URL, '_blank')} sx={{ cursor: 'pointer' }}>
          <Image
            style={{ height: isMobile ? '41px' : '27px' }}
            src="/static/icons/footer/app-store.svg"
            alt="app-store"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default DownloadApp;
